import Repository from "./masterRepository"
const GET_ISSUES = "getIssueTracker";
const ADD_ISSUES = "addIssueTracker";
const GET_ISSUE_STATUS_LIST = "getIssueStatus";
const GET_MODULE_LIST = "getModule";
const GET_FOUND_ON_LIST = "getFoundOn";
const GET_ISSUE_TYPE_LIST = "getIssueType";
const GET_SEVERITY_LIST = "getSeverity";
const GET_PRIORITY_LIST = "getPriority";
const GET_USERS_LIST = "getUsers";

export default {
    getIssueList(payload) {
        return Repository.post(transformRoute(GET_ISSUES), payload);
    },
    addIssueList(payload) {
        return Repository.post(transformRoute(ADD_ISSUES), payload);
    },
    getIssueStatusList(payload) {
        return Repository.post(transformRoute1(GET_ISSUE_STATUS_LIST), payload);
    },
    getIssueTypeList(payload) {
        return Repository.post(transformRoute1(GET_ISSUE_TYPE_LIST), payload);
    },
    getModuleList(payload) {
        return Repository.post(transformRoute1(GET_MODULE_LIST), payload);
    },
    getFoundOnList(payload) {
        return Repository.post(transformRoute1(GET_FOUND_ON_LIST), payload);
    },
    getSeverityList(payload) {
        return Repository.post(transformRoute1(GET_SEVERITY_LIST), payload);
    },
    getPriorityList(payload) {
        return Repository.post(transformRoute1(GET_PRIORITY_LIST), payload);
    },
    getUsers(payload) {
        return Repository.post(transformRoute2(GET_USERS_LIST), payload);
    },
    
}
const transformRoute = route => {
  return `/issuetracker/${route}`;
};
const transformRoute1 = route => {
  return `/issuetracker/issuetable/${route}`;
};
const transformRoute2 = route => {
  return `/users/${route}`;
};